import React, { createElement, Fragment } from 'react';
import Style from './index.module.scss';
import { Mask } from '@ifeng/lowcode_tool/src/components/Mask';
import { useChip, TYPE_Chip } from '@ifeng/lowcode_tool/src/hooks/useChip';
import { formatChip } from '@ifeng/lowcode_tool/src/method/chip';
import Chip from 'Chip';
import { getThumbnailFromRecommend } from '@ifeng/lowcode_tool/src/method/common';
import { formatImage } from '@ifeng/public_method';

export interface NewList_9_Props {
    nodeId?: string;
    style?: object;
    newsChip: TYPE_Chip;
    hoverColor: string;
    bigImageWidth?: number;
    imageWidth?: number;
    imageHeight?: number;
}

const NewList_9: React.FC<NewList_9_Props> = (props) => {
    const { nodeId, newsChip, style, bigImageWidth, imageWidth, hoverColor } = props;
    const newsChipData = useChip(newsChip);
    const chipComponentData = formatChip(newsChip);

    return (
        <Chip {...chipComponentData}>
            <div id={nodeId} className={Style.newsList} style={style}>
                {newsChipData?.[0] && (
                    <a
                        href={newsChipData[0]?.url}
                        className={Style.newsListBox}
                        target="_blank"
                        // @ts-ignore
                        style={{ '--color-hover': hoverColor }}
                    >
                        <div className={Style.index_first}>
                            <div
                                className={Style.index_left}
                                style={{
                                    width: bigImageWidth,
                                    height: Math.floor((bigImageWidth * 9) / 16),
                                }}
                            >
                                <img
                                    src={formatImage(
                                        getThumbnailFromRecommend(newsChipData[0]),
                                        bigImageWidth,
                                        Math.floor((bigImageWidth * 9) / 16),
                                    )}
                                    alt={newsChipData[0].title}
                                />
                            </div>
                            <div className={Style.index_right}>
                                <h1>{newsChipData[0].title}</h1>
                                <p>{newsChipData[0].summary}</p>
                                <span>详情</span>
                            </div>
                        </div>
                    </a>
                )}
                {newsChipData[1] && (
                    <div className={Style.index_otherList}>
                        {newsChipData.slice(1).map((item, index) => {
                            return (
                                <div className={Style.index_other} style={{ width: imageWidth }}>
                                    <a
                                        href={item.url}
                                        target="_blank"
                                        // @ts-ignore
                                        style={{ '--color-hover': hoverColor }}
                                    >
                                        <div className={Style.index_imgWp}>
                                            <img
                                                alt={item.title}
                                                style={{
                                                    width: imageWidth,
                                                    height: Math.floor((imageWidth * 9) / 16),
                                                }}
                                                src={formatImage(
                                                    getThumbnailFromRecommend(item),
                                                    imageWidth,
                                                    Math.floor((imageWidth * 9) / 16),
                                                )}
                                            />
                                        </div>
                                        <p>{item.title}</p>
                                    </a>
                                </div>
                            );
                        })}
                    </div>
                )}
                <Mask visible={!newsChip.id} zIndex={3}>
                    示例推荐位碎片—{newsChip.default.id}
                </Mask>
            </div>
        </Chip>
    );
};

export default NewList_9;
